// extracted by mini-css-extract-plugin
export default {"layout":"HomeCardSkeleton_layout__UZzpn","left":"HomeCardSkeleton_left__-orZv","right":"HomeCardSkeleton_right__ZMzLn"};